// extracted by mini-css-extract-plugin
export default {"dt":"option-prop_dt__ymULx","dd":"option-prop_dd__F6I0t","placeHolderShimmer":"option-prop_placeHolderShimmer__FCB3X"};